import { render, staticRenderFns } from "./ComplieRightStlye.vue?vue&type=template&id=095e39fc&scoped=true"
import script from "./ComplieRightStlye.vue?vue&type=script&lang=js"
export * from "./ComplieRightStlye.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightStlye.vue?vue&type=style&index=0&id=095e39fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e39fc",
  null
  
)

export default component.exports